import { Directive } from '@angular/core'

import { ThemeComponent } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: '[flxLayoutCollectionPrototype]',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [{ provide: ComponentType, useValue: ThemeComponent.CollectionPrototype }],
  host: {
    class: 'flx-collectionPrototype',
  },
})
export class FlxCollectionPrototypeThemeDirective {}
